interface IWizardStepIndicatorProps {
  currentStep: 1 | 2
}

/**
 * Step indicator for the asset selection wizard.
 * Shows ELD Provider (step 1) and Asset (step 2) with progress line.
 */
export const WizardStepIndicator = ({ currentStep }: IWizardStepIndicatorProps) => {
  return (
    <div className="px-5 py-3 border-b border-border shrink-0">
      <div className="flex items-center gap-2.5">
        {/* Step 1: ELD Provider */}
        <div
          className={`flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium transition-all ${
            currentStep >= 1 ? 'bg-emerald-500/20 text-emerald-400' : 'bg-muted text-muted-foreground'
          }`}
        >
          <span
            className={`w-4 h-4 rounded-full flex items-center justify-center text-[10px] ${
              currentStep > 1
                ? 'bg-emerald-500 text-white'
                : currentStep === 1
                  ? 'bg-emerald-500/30 text-emerald-400'
                  : 'bg-zinc-300 dark:bg-zinc-700'
            }`}
          >
            {currentStep > 1 ? '✓' : '1'}
          </span>
          ELD Provider
        </div>

        {/* Progress line */}
        <div className="flex-1 h-px bg-muted relative">
          <div
            className={`absolute inset-y-0 left-0 bg-emerald-500 transition-all duration-300 ${
              currentStep > 1 ? 'w-full' : 'w-0'
            }`}
          />
        </div>

        {/* Step 2: Asset */}
        <div
          className={`flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium transition-all ${
            currentStep >= 2 ? 'bg-emerald-500/20 text-emerald-400' : 'bg-muted text-muted-foreground'
          }`}
        >
          <span
            className={`w-4 h-4 rounded-full flex items-center justify-center text-[10px] ${
              currentStep === 2 ? 'bg-emerald-500/30 text-emerald-400' : 'bg-zinc-300 dark:bg-zinc-700'
            }`}
          >
            2
          </span>
          Asset
        </div>
      </div>
    </div>
  )
}
